import axios from 'axios';

import Logger from '@/Logger';

// Create instance of logger
const logger = new Logger('helpStore', 'Actions');

export default {
  getHelp({ commit }) {
    return new Promise(async (resolve, reject) => {
      try {
      // Get userdata
        const response = await axios.get('help');

        // Mutate state
        commit('updateHelp', response.data.toc);

        // Resolve promise
        resolve();

      // Catch errors
      } catch (error) {
      // Log action and status.
        logger.warn('authLogin', 'Response', { [error.response.status]: error.response.statusText });

        // Reject promise
        reject();
      }
    });
  },
};
